import { render, staticRenderFns } from "./DialogTag.vue?vue&type=template&id=c214d59a&scoped=true"
import script from "./DialogTag.vue?vue&type=script&lang=js"
export * from "./DialogTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c214d59a",
  null
  
)

export default component.exports